import { useQuery } from "@tanstack/react-query";

import { centralInvoiceRecipientQueries } from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientQueries.ts";
import type { BillingSettingsLookupData } from "~/modules/billing/utils/billingSettingsDisplayUtils.ts";
import { clientContactPersonQueries } from "~/modules/client/api/clientContactPerson/clientContactPersonQueries.ts";
import { useAllCurrencies } from "~/modules/country/api/currency/currencyQueries.ts";


type UseBillingSettingsLookupsResult = BillingSettingsLookupData & {
	isLoading: boolean;
};

export function useBillingSettingsLookups(clientId: string): UseBillingSettingsLookupsResult {
	const { data: currencies, isLoading: currenciesIsLoading } = useAllCurrencies();

	const { data: invoiceRecipients, isLoading: invoiceRecipientsIsLoading } = useQuery(
		centralInvoiceRecipientQueries.byClient(clientId),
	);

	const { data: clientContactPersons, isLoading: clientContactPersonsIsLoading } = useQuery(
		clientContactPersonQueries.all(),
	);

	return {
		currencies,
		invoiceRecipients,
		clientContactPersons,
		isLoading: invoiceRecipientsIsLoading || clientContactPersonsIsLoading || currenciesIsLoading,
	};
}